import * as preact from "preact";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";

export interface ITextBoxProps extends IDataControlProps
{
    onFocus?: (textBox: TextBox, event: FocusEvent) => void;
    onBlur?: (textBox: TextBox, event: FocusEvent) => void;
    onKeyDown?: (textBox: TextBox, event: KeyboardEvent) => void;
    onKeyPress?: (textBox: TextBox, event: KeyboardEvent) => void;
    onKeyUp?: (textBox: TextBox, event: KeyboardEvent) => void;
    onChange?: Function;
    onActionClick?: Function;
    IsMultiLine?: boolean;
    Descriptor?: string;
    DescriptorTop?: string;
    Value?: string;
    ActionImage?: string;
    IsPassword?: boolean;
    Watermark?: string;
}

export class TextBox extends DataControl<ITextBoxProps>
{
    public input: HTMLInputElement | HTMLTextAreaElement;

    constructor(props)
    {
        super(props);
    }

    public getValue(): string
    {
        return this.input.value;
    }

    public setValue(value)
    {
        this.input.value = value == null ? "" : value;
    }

    public getInputElement()
    {
        return this.input;
    }

    public hasFocus(): boolean
    {
        return document.activeElement === this.input;
    }

    public focus(): void
    {
        this.input && this.input.focus();
    }

    public selectAll(): void
    {
        $(this.input).select();
    }

    private _onChange()
    {
        this.props.onChange(this);
    }

    private _onActionImageClick()
    {
        if (this.props.onActionClick)
        {
            this.props.onActionClick(this);
        }
    }

    public override componentDidMount()
    {
        super.componentDidMount();
        this.setValue(this.props.Value);
    }

    public render()
    {
        return !this.props.IsMultiLine ? (
            <span className="textBox" ref={(ref) => this._registerContainer(ref)}>
                {this.props.Descriptor ? (<span className="inputLabel"> {this.props.Descriptor}</span>) : null}

                <input
                    ref={(ref) => { this.input = ref }}
                    autoComplete="new-password"
                    type={this.props.IsPassword ? "password" : "text"}
                    onFocus={(this.props.onFocus ? (event: FocusEvent) => { this.props.onFocus(this, event) } : null) as any}
                    onBlur={(this.props.onBlur ? (event: FocusEvent) => { this.props.onBlur(this, event) } : null) as any}
                    onKeyDown={(this.props.onKeyDown ? (event: KeyboardEvent) => { this.props.onKeyDown(this, event) } : null) as any}
                    onKeyUp={(this.props.onKeyUp ? (event: KeyboardEvent) => { this.props.onKeyUp(this, event) } : null) as any}
                    onKeyPress={(this.props.onKeyPress ? (event: KeyboardEvent) => { this.props.onKeyPress(this, event) } : null) as any}
                    onChange={this.props.onChange ? this._onChange.bind(this) : null}
                    placeholder={this.props.Watermark || null}
                />
                {this.props.ActionImage ? (<img src={this.props.ActionImage} onClick={this._onActionImageClick.bind(this)} />) : null}
        </span>
        ) : (
                <span className="textBox" ref={(ref) => this._registerContainer(ref)}>{this.props.Descriptor ? (<span className="inputLabel">{this.props.Descriptor}</span>) : null}
                <textarea
                        ref={(ref) => { this.input = ref }}
                        onFocus={(this.props.onFocus ? (event: FocusEvent) => { this.props.onFocus(this, event) } : null) as any}
                        onBlur={(this.props.onBlur ? (event: FocusEvent) => { this.props.onBlur(this, event) } : null) as any}
                        onKeyDown={(this.props.onKeyDown ? (event: KeyboardEvent) => { this.props.onKeyDown(this, event) } : null) as any}
                        onKeyUp={(this.props.onKeyUp ? (event: KeyboardEvent) => { this.props.onKeyUp(this, event) } : null) as any}
                        onKeyPress={(this.props.onKeyPress ? (event: KeyboardEvent) => { this.props.onKeyPress(this, event) } : null) as any}
                        onChange={this.props.onChange ? this._onChange.bind(this) : null}></textarea></span>
            );
    }
}